'use strict';

var $ = require('jquery');
var panzoom = require('jquery.panzoom');
var jqueryUi = require('jquery-ui-bundle');

module.exports = {
  $el: null,

  //Frame counter & UI
  ff: 0,
  lastFrame: 0,
  fCounter: 0,
  startTime: new Date(),

  //video feed rotation
  //Default Rotation
  rotate: 90,
  ctx: null,
  canvas: null,

  // Stream box & Device
  streamBox: null,
  deviceName: null,

  // large image rotation
  ctx2: null,
  canvas2: null,

  // Canvas support
  // true or false, defines if we should use canvas or img
  canvasSupport: null,

  // Sketchpad
  sketchpad: null,

  // Flash
  isFlashOn: false,
  flashToggeling: false,

  // Camera
  frontCamera: false,
  cameraToggeling: false,

  // Caputred Image Viewer
  $section: null,
  controlOutput: null,

  currentRotation: 0,

  init: function init(el) {
    this.$el = $(el);

    if (this.$el.length) {
      this.bindUiActions();
      this.getFrame();
    }
  },


  iePolyfill: function iePolyfill() {
    // IE 8 Fix for IndexOf
    if (!Array.prototype.indexOf) {
      Array.prototype.indexOf = function (elt /*, from*/) {
        var len = this.length >>> 0;
        var from = Number(arguments[1]) || 0;

        from = from < 0 ? Math.ceil(from) : Math.floor(from);

        if (from < 0) {
          from += len;
        }

        for (; from < len; from++) {
          if (from in this && this[from] === elt) {
            return from;
          }
        }

        return -1;
      };
    }
  },

  _initPanzoom: function _initPanzoom(_this, $section) {
    return $section.panzoom({
      exponential: false,
      $zoomIn: _this.$section.find('.zoom-in'),
      $zoomOut: _this.$section.find('.zoom-out'),
      $zoomRange: _this.$section.find('.zoom-range'),
      $reset: _this.$section.find('.reset')
    });
  },
  _initVideoContainer: function _initVideoContainer(_this) {
    $('#flash-toggle').click(function () {
      if (_this.flashToggeling || _this.frontCamera || _this.cameraToggeling) {
        return;
      }

      _this.toggleFlash();
      if (_this.isFlashOn) {
        _this.flashOff();
      } else {
        _this.flashOn();
      }
    });

    $('#camera-toggle').click(function () {
      if (_this.cameraToggeling) {
        console.log('I\'m toggleing');
        return;
      }

      _this.flashOff();
      _this.toggleCamera();
      if (!_this.frontCamera) {
        // $('#camera-toggle div:not('#camera-front-icon')').hide();
        $('#flash-toggle').addClass('disabled');
      } else {
        // $('#camera-toggle div:not('#camera-back-icon')').hide();
        $('#flash-toggle').removeClass('disabled');
      }
    });

    this.canvasSupport = this.isCanvasSupported();
    var $stream = $('#stream');

    // This must be before the `const $hollywood` code since it gets created here.
    if (!this.canvasSupport) {
      $('#c').remove();
      $stream.html('<img id="hollywood" src="/static/img/controls/spinner.gif" />');
    } else {
      this.canvas = document.getElementById('video-canvas');
      this.ctx = this.canvas.getContext('2d');
      this.canvas2 = document.getElementById('b');
      this.ctx2 = this.canvas2.getContext('2d');
    }

    $stream.css('overflow', 'hidden');
    if ($('html').hasClass('lt-ie9')) {
      $('#rotate-buttons').css('visibility', 'hidden');
      $('#zoom-controls').css('visibility', 'hidden');
    }

    var $myModal = $('#myModal');
    var $hollywood = $('#hollywood');

    $myModal.bind('hidden.bs.modal', function () {
      $('html').css('margin-right', '0px');
    });

    $myModal.bind('show.bs.modal', function () {
      $('html').css('margin-right', '-15px');
    });

    $('#rotate-right').click(function () {
      var angle = $hollywood.data('angle') + 90 || 90;
      $hollywood.css({ transform: 'rotate(' + angle + 'deg)' });
      $hollywood.data('angle', angle);

      // set global rotation value
      _this.currentRotation = angle;
      console.log('angle: ' + _this.currentRotation);
    });

    $('#rotate-left').click(function () {
      var angle = $hollywood.data('angle') - 90 || -90;
      $hollywood.css({ transform: 'rotate(' + angle + 'deg)' });
      $hollywood.data('angle', angle);

      // set global rotation value
      _this.currentRotation = angle;
      console.log('angle: ' + _this.currentRotation);
    });

    $('#capture-button').click(function () {
      $('#downloadSnap-1').prop('disabled', false);
      $('#downloadSnap-2').prop('disabled', false);
      _this.takeSnapshotClicked();
    });

    $('#delete-snapshot').click(function () {
      _this.deleteSnapshot();
    });
  },
  _initSnapshotContainers: function _initSnapshotContainers(_this) {
    $('#open-editor').click(function () {
      var $editSnapshot = $('#editSnapshot');
      var $drawingLayer = $('#drawing-layer');

      setTimeout(function () {
        $editSnapshot.removeClass('hundo');
        $editSnapshot.attr('src', $('#activeSnapshot').attr('src'));

        var marginleft = ($editSnapshot.parent('.modal-body').innerWidth() - $editSnapshot.innerWidth()) / 2;
        $editSnapshot.css('margin-left', marginleft);

        $drawingLayer.css('marginleft', marginleft);
        $drawingLayer.css('height', $editSnapshot.height());
        $drawingLayer.css('width', $editSnapshot.width());
      }, 1000);
    });

    $(window).resize(function () {
      _this.sizePreview();
    });

    _this.sizePreview();

    $('div').on('click', '.closeDiv', function () {
      var snapDeleteID = $(this).attr('id');
      var snapID = snapDeleteID.replace('delete-', '');
      $('#' + snapID).remove();
      $('#' + snapDeleteID).remove();
      $('.' + 'container-' + snapID).remove();
      console.log('item deleted');
    });

    // Bind pastSnapshots for future snapshots
    $('#pastSnapshots').on('click', '.snap-item', function (ev) {
      // Snapshot id
      var sid = $(ev.target).data('sid');
      _this.showSnapshot(sid);
    });

    var $activeSnapshot = $('#activeSnapshot');
    $activeSnapshot.dblclick(function () {
      // calls panzoom zoom function click
      $('#capture-snaper').first().find('.zoom-in').click();
    });

    var $imageDownloadForm = $('#imageDownloadForm');
    $imageDownloadForm.submit(function () {
      // Set hidden input to have data of the current screenshot
      var $imageDataInput = $imageDownloadForm.find('input[name="imageData"]');
      var $rotationInput = $imageDownloadForm.find('input[name="rotation"]');
      $imageDataInput.attr('value', $('#activeSnapshot').attr('src'));
      $rotationInput.attr('value', $('#activeSnapshot').data('rotate'));
    });
  },
  bindUiActions: function bindUiActions() {
    var _this = this;
    this.$section = $('#capture-snaper').first();
    this.deviceName = $('#deviceName').data('name');

    // Initialize Panzoom container
    this._initPanzoom(_this, this.$section.find('.panzoom'));

    // Initialize all elements in the streaming video container
    this._initVideoContainer(_this);

    // Initialize snapshot containers
    this._initSnapshotContainers(_this);

    this.bindResizeEvents();
  },
  isCanvasSupported: function isCanvasSupported() {
    return false;
    var elem = document.createElement('canvas');
    return !!(elem.getContext && elem.getContext('2d'));
  },
  inviteClicked: function inviteClicked() {
    $.post('/ttux/invite');
  },


  // adds border to snapshot
  select: function select(id) {
    $('.snapshot').removeClass('active');
    $('#' + id).toggleClass('active');
    this.$section.find('.panzoom').panzoom('reset');
  },


  /**
   *
   * @param id
   */
  showSnapshot: function showSnapshot(id) {
    var $selected = $('#' + id);
    var imageRotation = $selected.data('rotate');

    // Active snapshot is the snapshot in the preview pane
    var $activeSnapshot = $('#activeSnapshot');

    // currentSelected is the currently selected thumbnail (with active class on)
    var $currentSelected = $('#pastSnapshots').find('.active');

    $activeSnapshot.attr('src', $selected.attr('src'));
    $activeSnapshot.css({ transform: 'rotate(' + imageRotation + 'deg)' });
    $activeSnapshot.data('rotate', imageRotation);

    this.updateTextArea($currentSelected, $selected);

    // Select method should occur after saving associated text data to thumbnails
    this.select(id);
  },
  deleteSnapshot: function deleteSnapshot(id) {
    console.log('Snapshot deleted');
  },
  updateTextArea: function updateTextArea($currentSelected, $next) {
    // Get current textarea el for currently selected snapshot
    var $snapText = $('#snapText');
    var snapValue = $snapText.val();

    if ($currentSelected == null) {
      $snapText.val('');
    } else {
      // Save the text to the currently selected el and reset
      $currentSelected.attr('data-snaptext', snapValue);

      // If the $next el has data in it, replace $snapText data
      $snapText.val($next.attr('data-snaptext'));
    }
  },
  makeid: function makeid() {
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var text = '';

    for (var i = 0; i < 15; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  },
  toggleFlash: function toggleFlash() {
    var _this = this;
    this.flashToggeling = true;

    $.ajax({
      url: '/ttux/flashlight/' + this.deviceName
    }).done(function (data) {
      console.log(data);
      _this.flashToggeling = false;
      if (data.status === 'on') {
        _this.flashOn();
      } else if (data.status === 'off') {
        _this.flashOff();
      } else {
        console.log('Something went wrong with the flash');
      }
    });
  },
  takeSnapshotClicked: function takeSnapshotClicked() {
    var _this = this;
    var ie = !!$('html').hasClass('lt-ie9');

    $.post('/ttux/snapshot/' + this.deviceName, { ie: ie }, function (data) {
      var dataUri = void 0;
      var $activeSnapshot = $('#activeSnapshot');

      if (ie) {
        dataUri = '/ttux/ie-snapshot/' + _this.deviceName + '/' + _this.makeid();
      } else {
        dataUri = 'data:image/jpeg;base64,' + data.image;
      }

      if (_this.canvasSupport && !ie) {
        var image = new Image();
        image.src = dataUri;
        image.onload = function () {
          var cw = image.width;
          var ch = image.height;
          var cx = 0;
          var cy = 0;
          var ratio = cw / ch;

          //Calculate new canvas size and x/y coorditates for image
          switch (_this.rotate) {
            case 90:
              cw = image.height;
              ch = image.width;
              cy = image.height * -1;
              break;
            case 180:
              cx = image.width * -1;
              cy = image.height * -1;
              break;
            case 270:
              cw = image.height;
              ch = image.width;
              cx = image.width * -1;
              break;
          }

          //Rotate image
          _this.canvas2.setAttribute('width', cw);
          _this.canvas2.setAttribute('height', ch);
          _this.ctx2.rotate(rotate * Math.PI / 180);
          _this.ctx2.drawImage(image, cx, cy); //Display Image in Canvas
          dataUri = _this.canvas2.toDataURL();

          $activeSnapshot.attr('src', dataUri);
          $activeSnapshot.css('margin-left', ($('#snapshots').innerWidth() - $('#activeSnapshot').innerWidth()) / 2);

          var id = 'snapshot-' + new Date().getTime().toString();
          if (_this.rotate === 90 || _this.rotate === 270) {
            smwidth = 45;
            smheight = 45 * ratio;
          } else {
            smwidth = 45 * ratio;
            smheight = 45;
          }

          var imageElement = $.parseHTML('<img class="snapshot-item snapshot" \n             id="' + id + '" src="' + dataUri + '" width="' + String(smwidth) + '"\n             height="' + String(smheight) + '" onclick="window.parent.showSnapshot(\'' + id + '\')">');

          var container = document.createElement('div');

          // maybe make class unique, or an id via the const id above
          container.setAttribute('class', 'container-' + id);
          container.setAttribute('style', 'display: inline-flex;');

          // create delete icon
          var div = document.createElement('div');
          div.setAttribute('class', 'closeDiv');
          div.setAttribute('id', 'delete-' + id);

          var $container = $(container);
          $container.append(imageElement);
          $container.append(div);

          $('#pastSnapshots').append($container);

          _this.select(id);
        };
      } else {
        // Canvas should not be called, so this code is executed
        var id = 'snapshot-' + new Date().getTime().toString();
        var currentRotation = _this.currentRotation;
        console.log('current: ' + currentRotation);

        $activeSnapshot.attr('src', dataUri);
        $activeSnapshot.css({ transform: 'rotate(' + currentRotation + 'deg)' });
        $activeSnapshot.data('rotate', currentRotation);
        _this.$section.find('.panzoom').panzoom('reset');

        var imageElement = $.parseHTML('<img data-sid=\'' + id + '\' \n            class=\'snap-item snapshot\' id=\'' + id + '\' src=\'' + dataUri + '\' \n            width=\'75\' height=\'50\' data-snaptext="" data-rotate=\'' + currentRotation + '\'>');

        var container = document.createElement('div');

        // maybe make class unique, or an id via the const id above
        container.setAttribute('class', 'container-' + id);
        container.setAttribute('style', 'display: inline-flex;');

        // Uncomment this line to set rotation on snapshot panel
        //container.style.transform = 'rotate(' + currentRotation + 'deg)';

        // create delete icon
        var div = document.createElement('div');
        div.setAttribute('class', 'closeDiv');
        div.setAttribute('id', 'delete-' + id);

        var $container = $(container);
        $container.append(imageElement);
        $container.append(div);

        // set annotation textarea sid to this snapShot id
        //$('#snapText').val('')
        //$('#snapText').attr('data-sid', id);
        console.log('snapshot taken');
        _this.updateTextArea(null, '#' + id);

        $('#pastSnapshots').append($container);

        //$('#capture-snaper').css('cssText','height: auto !important');
        //$('#cap-body').css('cssText','height: auto !important');

        _this.select(id);
      }
    });
  },


  /**
   * Contains the main logic for requesting and processing command and image
   * frames requested from the server.
   */
  getFrame: function getFrame() {
    var _this = this;

    $.ajax({
      url: '/ttux/lastFrame/' + this.deviceName + '/' + this.lastFrame
    }).done(function (msg) {
      var fnumber = msg.substring(0, 8);
      var beginImgData = 8;

      if (msg.substring(0, 2) === '!!') {
        var beginEnd = msg.indexOf('!!', 2);
        var control = $.parseJSON(msg.substring(2, parseInt(beginEnd, 10)));
        _this.controlOutput = control;

        if (control.command === 'update_controls' && !$('html').hasClass('lt-ie9')) {
          if (control.parameters.indexOf('flash') !== -1) {
            $('#flash-toggle').show();
          }

          if (control.parameters.indexOf('flip') !== -1) {
            $('#camera-toggle').show();
          }
        }

        fnumber = msg.substring(parseInt(beginEnd, 10) + 2, parseInt(beginEnd, 10) + 10);
        beginImgData = parseInt(beginEnd, 10) + 10;
      }

      _this.lastFrame = fnumber;
      if (msg.substring(8).length > 0) {
        var videoSrc = 'data:image/jpg;base64,' + msg.substring(beginImgData);

        if (_this.canvasSupport) {
          var image = new Image();
          image.src = videoSrc;

          image.onload = function () {
            var cw = image.width;
            var ch = image.height;
            var cx = 0;
            var cy = 0;

            // Calculate new canvas size and x/y coorditates for image
            switch (_this.rotate) {
              case 90:
                cw = image.height;
                ch = image.width;
                cy = image.height * -1;
                break;
              case 180:
                cx = image.width * -1;
                cy = image.height * -1;
                break;
              case 270:
                cw = image.height;
                ch = image.width;
                cx = image.width * -1;
                break;
            }

            //  Rotate image
            _this.canvas.setAttribute('width', cw);
            _this.canvas.setAttribute('height', ch);
            _this.ctx.rotate(_this.rotate * Math.PI / 180);

            //Scales the image down if it won't fit in the box
            if (cw > _this.streamBox.innerWidth()) {
              _this.ctx.scale(_this.streamBox.innerWidth() / cw, _this.streamBox.innerWidth() / cw);

              // streamBox.css('height',ch*streamBox.innerWidth()/cw+'px');
            }

            _this.ctx.drawImage(image, cx, cy); //Display Image in Canvas
          };
        } else {
          //If canvas is not supported display in img tag
          $('#hollywood').attr('src', videoSrc);
        }

        var now = new Date();
        var min = Math.floor((now - _this.startTime) / 1000);
        var sec = (now - _this.startTime) % 1000;

        $('#stream_status').html(min + '.' + sec + ' f: ' + _this.fCounter);
        _this.fCounter++; //Adds to frame couter
      }

      _this.getFrame(); //Let the function call itself
    });

    //.error(function (msg) {
    // console.log('got error');
    // setTimeout('frameOne_jq()', 500);
    // });
  },
  toggleCamera: function toggleCamera() {
    var _this = this;
    this.cameraToggeling = true;

    $.ajax({
      url: '/ttux/flipcamera/' + this.deviceName
    }).done(function (data) {
      _this.cameraToggeling = false;
      if (data.status === 'front') {
        _this.frontCamera = true;
        $('#camera-front-icon').show();
        $('#flash-toggle').addClass('disabled');
      } else if (data.status === 'back') {
        _this.frontCamera = false;
        $('#camera-back-icon').show();
        $('#flash-toggle').removeClass('disabled');
      }
    });
  },
  sizePreview: function sizePreview() {
    if ($('body').innerWidth() > 992) {
      var snaperh = $(window).height() - 110 - 30;
      $('#capture-snaper').css('height', 'auto');
      $('#cap-body').css('height', 'auto');
    } else {
      $('#cap-body').css('height', 'auto');
    }
  },
  flashOn: function flashOn() {
    this.isFlashOn = true;
    var $flashToggle = $('#flash-toggle');
    $flashToggle.html('<img style="height: 50px;" src="/static/img/controls/open103off.png">');
    $flashToggle.removeClass('active');
  },
  flashOff: function flashOff() {
    this.isFlashOn = false;
    var $flashToggle = $('#flash-toggle');
    $flashToggle.html('<img style="height: 50px;" src="/static/img/controls/open103.png">');
    $flashToggle.removeClass('active');
  },


  /*
   * This function is to allow or disable resizing of the container before stream has loaded in
   */
  locateStream: function locateStream() {
    // see if stream elementExists
    // if it does not, disable resizing?
    var $elementExists = $('#hollywood');
    if (!$elementExists) {
      console.log('Cannot find hollywood');
    } else {
      console.log('hollywood exists');
    }
  },


  /**
   * Bindings to adjust layout based on window size.
   */
  bindResizeEvents: function bindResizeEvents() {
    // Window resizing adjustments
    var $resizable = $('.resizable');
    var $resizableRight = $('.resizable-right');

    var $videoContainer = $('#video-container');
    var $snapContainer = $('#snap-container');

    this.locateStream();

    $(window).resize(function () {
      console.log('window resize here');

      // sets snapContainer width to percentage of screen
      var calc = $(window).width() / 100 * 40;
      $snapContainer.css('width', calc);
      $snapContainer.css('width', $('#first-right').width());

      // sets maxWidth based on screen percentage
      $resizableRight.resizable('option', 'maxWidth', calc);

      setOffset();
      checkoverlap();
    });

    /**
     * Checks if videoStream container and Snapshot viewer are overlapping
     */
    function checkoverlap() {
      var positionLeft = $resizable.offset().left + $resizable.width();
      var positionRight = $resizableRight.offset().left;

      if (positionLeft > positionRight) {
        // overlapping = TRUE
        console.log('overlapping!');
      }
    }

    function setOffset() {
      // sets snapshot resizable, to the top left corner of its div, upon window resize
      var positionRight = $resizableRight.offset().left;
      var positionRightParent = $('#first-right').offset();

      $resizableRight.offset({ top: positionRightParent.top, left: positionRightParent.left });
    }

    $resizableRight.resizable({
      //containment: '#first-right',
      disabled: true,
      snap: '#first-right', snapMode: 'inner',
      aspectRatio: false,
      handles: 'sw',
      minHeight: 400,
      minWidth: 400,
      maxHeight: 670,
      resize: function resize(event, ui) {
        // sets maxWidth based on screen percentage
        var calc = void 0;
        console.log('CALCpercentpixel: ' + calc);

        //if column layout, set percentage to 94
        if ($(window).width() < 950) {
          calc = $(window).width() / 100 * 94;
          $resizableRight.resizable('option', 'maxWidth', calc);
        } else {
          calc = $(window).width() / 100 * 40;
          $resizableRight.resizable('option', 'maxWidth', calc);
        }
      }
    }).on('resize', function (e) {
      e.stopPropagation();
    });
  }
};
